import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom'
import styled from 'styled-components'

import A from 'shared/A'
import Div from 'shared/Div'
import Flex from 'shared/Flex'
import X from 'components/X'

import Link from 'shared/Link'

let Wrapper = styled.div`
  position: fixed;
  height: 100vh;
  width:100vw;
  top:0;
  left:0;
  z-index: 100;
  background:white;

  a {
    margin-bottom: 40px;
  }

  &:before {
    content: "";
    width: 100%;
    height: 600px;
    top: -600px;
    position: absolute;
    background:white;
  }
  &:after {
    content: "";
    width: 100%;
    height: 600px;
    bottom: -600px;
    position: absolute;
    background: white;
  }
`


class MobileNav extends Component {

  render() {

    return (
      <Wrapper>
        <X onClick={() => this.props.closeMenu()}></X>
        <Flex column center height="100%">
          <Link background="white" border="true" padding="0 10px" margin="0 1.5em 0 0" onClick={() => this.props.closeMenu()} to="/collections/AW19">
            Collections
          </Link>
          <A background="white" border="true" padding="0 10px" margin="0 1.5em 0 0" onClick={() => this.props.closeMenu()} href="https://shop.barragannnn.com/" target="_blank">Shop</A>
          <A background="white" border="true" padding="0 10px" margin="0 1.5em 0 0" onClick={() => this.props.closeMenu()} href="https://shop.barragannnn.com/pages/policy-1" target="_blank">Policy</A>
          <Link background="white" border="true" padding="0 10px" margin="0 1.5em 0 0" onClick={() => this.props.closeMenu()} to="/contact">Contact</Link>
          <A background="white" border="true" padding="0 10px" margin="0 1.5em 0 0" onClick={() => this.props.closeMenu()} href="https://www.instagram.com/barragan/" target="_blank">@barragan</A>
          <Link background="white" border="true" padding="0 10px" margin="0 1.5em 0 0" onClick={() => this.props.closeMenu()} to="/accessibility">Accessibility</Link>
        </Flex>
      </Wrapper>

    )
  }
}

export default MobileNav;



// WEBPACK FOOTER //
// ./src/components/MobileNav.js